import React from 'react'
import AuthButton from '../Button/AuthButton'
import SettingButton from '../Button/SettingButton'

const ExtensionAlert = () => {
    return (
        <>
            <div className="container mb-4">
                <div className="inner-wrapper border-layout-border shadow-[0px_1px_2px_0px_#0000000D] z-50 flex justify-between items-center h-[56px] bg-[#FEF3F2] border border-[#FECDD6] border-extension-alert rounded-lg py-4 px-4">
                    <div className="left-content flex justify-between items-center gap-4">
                        <div className=" flex items justify-center items-center space-x-2 ">
                            <div className='flex justify-center items-center space-x-2'>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.4375 5.5625C7.4375 5.31527 7.51081 5.0736 7.64817 4.86804C7.78552 4.66248 7.98074 4.50226 8.20915 4.40765C8.43756 4.31304 8.68889 4.28829 8.93137 4.33652C9.17384 4.38475 9.39657 4.5038 9.57139 4.67862C9.7462 4.85343 9.86525 5.07616 9.91348 5.31864C9.96172 5.56111 9.93696 5.81245 9.84235 6.04085C9.74774 6.26926 9.58753 6.46448 9.38197 6.60184C9.1764 6.73919 8.93473 6.8125 8.6875 6.8125C8.35598 6.8125 8.03804 6.6808 7.80362 6.44638C7.5692 6.21196 7.4375 5.89402 7.4375 5.5625ZM17.4375 9C17.4375 10.6688 16.9427 12.3001 16.0155 13.6876C15.0884 15.0752 13.7706 16.1566 12.2289 16.7952C10.6871 17.4338 8.99064 17.6009 7.35393 17.2754C5.71721 16.9498 4.2138 16.1462 3.03379 14.9662C1.85378 13.7862 1.05019 12.2828 0.724628 10.6461C0.399065 9.00936 0.566156 7.31286 1.20477 5.77111C1.84338 4.22936 2.92484 2.9116 4.31238 1.98448C5.69992 1.05735 7.33122 0.5625 9 0.5625C11.237 0.564981 13.3817 1.45473 14.9635 3.03653C16.5453 4.61833 17.435 6.763 17.4375 9ZM15.5625 9C15.5625 7.70206 15.1776 6.43327 14.4565 5.35407C13.7354 4.27487 12.7105 3.43374 11.5114 2.93704C10.3122 2.44034 8.99272 2.31038 7.71972 2.5636C6.44672 2.81681 5.2774 3.44183 4.35962 4.35961C3.44183 5.27739 2.81682 6.44672 2.5636 7.71972C2.31038 8.99272 2.44034 10.3122 2.93704 11.5114C3.43374 12.7105 4.27488 13.7354 5.35407 14.4565C6.43327 15.1776 7.70206 15.5625 9 15.5625C10.7399 15.5606 12.408 14.8686 13.6383 13.6383C14.8686 12.408 15.5606 10.7399 15.5625 9ZM9.9375 11.8656V9.3125C9.9375 8.8981 9.77288 8.50067 9.47986 8.20764C9.18683 7.91462 8.7894 7.75 8.375 7.75C8.1536 7.74967 7.93923 7.82771 7.76986 7.97029C7.60048 8.11287 7.48703 8.31079 7.4496 8.52901C7.41217 8.74722 7.45318 8.97164 7.56536 9.16251C7.67754 9.35339 7.85365 9.4984 8.0625 9.57187V12.125C8.0625 12.5394 8.22712 12.9368 8.52015 13.2299C8.81317 13.5229 9.2106 13.6875 9.625 13.6875C9.8464 13.6878 10.0608 13.6098 10.2301 13.4672C10.3995 13.3246 10.513 13.1267 10.5504 12.9085C10.5878 12.6903 10.5468 12.4659 10.4346 12.275C10.3225 12.0841 10.1464 11.9391 9.9375 11.8656Z" fill="#F63D68" />
                                </svg>

                                <div className="items flex flex-start"> <span className='text-[#384250]  text-base font-bold '>Warning</span></div>
                            </div>
                            <div className='flex '>
                                <p className='warning text-sm text-black'>   We have detected that you have not installed the TestTube extension.</p>
                            </div>



                        </div>


                    </div>

                    <div className="right-content flex justify-between items-center gap-4">
                        <div className="sub right-items">


                        </div>
                        <div className="sub right-items font-bold ">
                           
                            <a
                                className={"w-full  inline-flex items-center justify-center py-2.5 px-3  text-sm font-semibold text-white  hover:bg-hover focus:outline-none bg-[#111322] rounded-lg border"
                                }
                                id='add_extension'
                                href="https://chromewebstore.google.com/detail/testtube-no-code-qa-autom/pbcljcpjmdhgpffgalkifignmbnedikk"
                                target="_blank"
                            >
                                Install Extension


                            </a>
                           


                        </div>

                        {/* <div className="sub right-items">

                            <div className="close-icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.22664 0.811448C1.83611 0.420924 1.20295 0.420924 0.812424 0.811448C0.4219 1.20197 0.4219 1.83514 0.812424 2.22566L6.58716 8.0004L0.812484 13.7751C0.42196 14.1656 0.42196 14.7988 0.812484 15.1893C1.20301 15.5798 1.83617 15.5798 2.2267 15.1893L8.00137 9.41461L13.776 15.1893C14.1666 15.5798 14.7997 15.5798 15.1903 15.1893C15.5808 14.7988 15.5808 14.1656 15.1903 13.7751L9.41559 8.0004L15.1903 2.22566C15.5808 1.83514 15.5808 1.20197 15.1903 0.811448C14.7998 0.420924 14.1666 0.420924 13.7761 0.811448L8.00137 6.58618L2.22664 0.811448Z" fill="#818181" />
                                </svg>
                            </div>

                        </div> */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExtensionAlert